<template>
  <div class="grow relative">
    <div
      ref="search"
      class="flex items-center rounded-[8px] overflow-hidden w-full border-[1px] border-[#E2E2E2]"
      :class="loading || disabled ? 'bg-[#efefef]' : 'bg-[#FFFFFF]'"
    >
      <div class="flex flex-col gap-[5px] w-full">
        <div
          v-if="selectedValue.length > 0"
          class="flex flex-wrap gap-[8px] text-[#333333] p-[10px] pb-0"
        >
          <div
            v-for="item, idx in selectedValue"
            :key="`label-${idx}`"
            class="flex items-center gap-[5px] px-[10px] py-[6px] min-h-[30px] rounded-[4px]"
            :class="loading || disabled ? 'bg-[#E6E6E6]' : 'bg-[#FFECE9]'"
          >
            <span class="text-[12px]">{{ item.text }}</span>
            <i
              v-if="!loading && !disabled"
              class="k-close-circle text-[14px] cursor-pointer"
              @click="() => removeOption(item.value)"
            />
          </div>
        </div>
        <b-form-input
          :id="name"
          ref="searchMulti"
          :value="modelSearch"
          autocomplete="off"
          type="search"
          :placeholder="placeholder"
          debounce="500"
          class="border-0 shadow-none !text-[14px] !p-[10px]"
          size="lg"
          :disabled="loading || disabled"
          @focus="onFocus"
          @blur="onBlur"
          @update="value => $emit('update:modelSearch', value)"
        />
      </div>
      <b-spinner
        v-if="loading"
        small
        class="mr-[16px]"
      />
      <i
        v-else
        class="k-arrow-down-1 mr-[12px] text-[24px] cursor-pointer"
        @click="$refs.searchMulti.focus()"
      />
    </div>
    <small
      v-if="error"
      class="text-danger"
    >{{ error }}</small>
    <div
      class="absolute z-[1] komsearch rounded-[8px] bg-[#FFFFFF] transition-opacity duration-300 hover:!pointer-events-auto hover:!opacity-100"
      :class="[
        focused ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        { 'shadow-[0_4px_4px_0] shadow-black/25': mode === 'invoice' },
        { 'border-[1px] border-[#E2E2E2] overflow-hidden w-full': mode === 'default' }
      ]"
      :style="{ top: `${height}px` }"
      @mouseover="isFocus = true"
      @mouseleave="handleMouseLeave"
    >
      <div v-if="options.length > 0">
        <template v-if="mode === 'invoice'">
          <span class="block truncate w-full text-[12px] text-[#FBA63C] p-[10px]">Hanya bisa memilih maksimal 4</span>
          <b-form-checkbox-group
            :id="`${name}-group`"
            :checked="modelValue"
            :name="`${name}-group`"
            class="p-[10px] pt-0 overflow-y-auto"
            style="max-height: 248px;"
            stacked
          >
            <div
              v-for="(item, idx) in options"
              :key="`option-${idx}`"
              class="p-[10px] [&_label]:w-full"
              :class="{ '[&_label]:cursor-pointer': !disabledOption(item.value) }"
            >
              <b-form-checkbox
                :id="`${name}-${item.value.toString()}`"
                :value="item.value"
                :name="name"
                :disabled="disabledOption(item.value)"
                @change="e => onChange(item.value, e)"
              >
                {{ item.text }}
              </b-form-checkbox>
            </div>
          </b-form-checkbox-group>
        </template>
        <template v-if="mode === 'default'">
          <div
            :id="`${name}-group`"
            class="flex flex-col overflow-y-auto"
            style="max-height: 248px;"
          >
            <label
              v-for="(item, idx) in options"
              :key="idx"
              :for="`${name}-${item.value.toString()}`"
              :aria-label="name"
              class="px-[12px] py-[10px] mb-0 min-h-[40px] flex flex-row-reverse items-center justify-between gap-[16px] cursor-pointer text-[14px] transition-colors duration-300"
              :class="modelValue.includes(item.value) ? 'text-[#FFFFFF] bg-[#F95031]' : 'text-[#222222] bg-[#FFFFFF] hover:bg-[#FCD4BE]'"
            >
              <input
                :id="`${name}-${item.value.toString()}`"
                type="checkbox"
                :name="name"
                :value="item.value"
                class="hidden"
                @change="e => onChange(item.value, e)"
              >
              <div class="flex justify-end items-center w-[60px]">
                <i
                  class="k-Checklist text-[#FFFFFF] transition-opacity duration-300 text-[28px]"
                  :class="modelValue.includes(item.value) ? 'opacity-100' : 'opacity-0'"
                />
                <button
                  v-if="editableOptions && idx >= masterOptionsNumber"
                  aria-label="edit"
                  :class="modelValue.includes(item.value) ? 'hover:bg-[#FFFFFF] hover:text-[#F95031] active:bg-[#FCD4BE]' : 'hover:bg-[#F95031] hover:text-[#FFFFFF] active:bg-[#FFFFFF] active:text-[#F95031]'"
                  class="w-[24px] h-[24px] grid place-items-center rounded transition-colors duration-300 outline-none border-none"
                  @click="() => handleEditOption(idx)"
                >
                  <i
                    class="text-[16px]"
                    :class="isFocusEdit[idx] ? 'k-tick-circle' : 'k-edit-2'"
                  />
                </button>
              </div>
              <b-form-input
                v-if="isFocusEdit[idx]"
                :id="`${name}-multi-edit-${idx}`"
                :value="item.text"
                type="text"
                placeholder="Edit alasan bounce"
                @keydown="e => limitInput(e, `${name}-multi-edit-${idx}`)"
                @keyup.enter="() => handleEditOption(idx)"
              />
              <span v-else>{{ item.text }}</span>
            </label>
          </div>
          <div class="px-[12px] py-[8px] flex gap-[8px] border-t border-[#E2E2E2]">
            <b-form-input
              :id="`${name}-multi-add`"
              type="text"
              class="!bg-[#F8F8F8] !border-[#EBEBEB] !shadow-none"
              placeholder="Masukkan alasan lainnya"
              @blur="handleMouseLeave"
              @keydown="e => limitInput(e, `${name}-multi-add`)"
              @keyup.enter="handleAddOption"
            />
            <b-button
              variant="outline-primary"
              :disabled="loadingAddOption"
              class="!px-[12px] h-[36px] !flex items-center gap-[8px] !text-[14px] font-medium disabled:!opacity-100 disabled:!border-[#E2E2E2] disabled:pointer-events-none disabled:!text-[#C2C2C2]"
              @click="handleAddOption"
            >
              <b-spinner
                v-if="loadingAddOption"
                small
              />
              <i
                v-else
                class="k-add text-2xl"
              />
              Tambahkan
            </b-button>
          </div>
        </template>
      </div>
      <span
        v-else
        class="p-[10px] text-[12px] text-[#333333] font-semibold block w-full text-center"
      >Tidak Ada Opsi</span>
    </div>
  </div>
</template>

<script>
/**
 * @component MultiSelectDropdown
 * @description
 * A multi-select dropdown component with search, inline editing, and the ability
 * to add custom options. Designed for selecting multiple values
 *
 * Features:
 * - Search input with debounce
 * - Selected options displayed as tags
 * - Two display modes: `invoice` (checkbox group) and `default` (custom dropdown with checkboxes + edit)
 * - Ability to add new options manually
 * - Ability to edit existing options (if `editableOptions` is true)
 * - Validation: maximum of 4 selections
 *
 * @props {String} name - Unique name for the component (default: 'check')
 * @props {String} placeholder - Placeholder for the search input (default: 'Pilih Talent Lead')
 * @props {Boolean} disabled - Disabled attribute for the search input (default: false)
 * @props {Boolean} loading - Loading state for the search input (default: false)
 * @props {Boolean} loadingAddOption - Loading state for the add option button (default: false)
 * @props {String} modelSearch - Bound value for the search input (default: '')
 * @props {Array<{ value: string|number, text: string }>} options - List of available options (default: [])
 * @props {Array<string|number>} modelValue - Currently selected option values (default: [])
 * @props {('invoice'|'default')} mode - Dropdown display mode (default: 'invoice')
 * @props {Boolean} editableOptions - Whether options can be edited inline (default: false)
 * @props {Number} masterOptionsNumber - Number of master (non-editable) options (default: 6)
 * @props {Boolean} pushableOptions - Whether new options can be pushed/added (default: false)
 * @props {String} error - Error message to display (default: '')
 * @props {Number} maxPusehedOptionLen - Set maximum length of inputed custom option (default: 50)
 *
 * @emits update:modelSearch - Triggered when the search input changes
 * @emits update:modelValue - Triggered when the selection changes
 * @emits update:options - Triggered when an option is edited
 * @emits onBlur - Triggered when the dropdown loses focus
 * @emits onAddOption - Triggered when a new option is added
 */

export default {
  props: {
    name: {
      type: String,
      default: 'check',
    },
    placeholder: {
      type: String,
      default: 'Pilih Talent Lead',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingAddOption: {
      type: Boolean,
      default: false,
    },
    modelSearch: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'invoice',
    },
    editableOptions: {
      type: Boolean,
      default: false,
    },
    masterOptionsNumber: {
      type: Number,
      default: 6,
    },
    pushableOptions: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    maxPusehedOptionLen: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      isFocus: false,
      isFocusEdit: this.options.map(() => false),
      localValue: '',
      selectedValue: [],
      height: 48.5,
    }
  },
  computed: {
    focused() {
      const addEl = document.getElementById(`${this.name}-multi-add`)
      return this.isFocus || this.isFocusEdit.some(f => f) || (addEl && document.activeElement === addEl)
    },
  },
  watch: {
    isFocus(value) {
      this.height = this.$refs.search.clientHeight + 7.5
      if (!value) {
        const isNotChanged = JSON.stringify(this.modelValue) === this.localValue
        if (!isNotChanged) this.$emit('update:modelSearch', '')
        this.$emit('onBlur', isNotChanged)
      }
    },
    modelValue: {
      handler(value) {
        this.selectedValue = value.map(v => this.options.find(option => option.value === v))
      },
      immediate: true,
    },
    options(value) {
      this.selectedValue = this.selectedValue.map(sel => {
        const match = value.find(opt => opt.value === sel.value)
        return match ? { ...sel, text: match.text } : sel
      })
    },
  },
  methods: {
    onFocus() {
      this.isFocus = true
      this.localValue = JSON.stringify(this.modelValue)
    },
    onBlur({ relatedTarget }) {
      const group = document.getElementById(`${this.name}-group`)
      if (relatedTarget !== group) {
        this.isFocus = false
      }
    },
    onChange(value, change) {
      let changes = change
      if (change.target) {
        const isRemoved = this.modelValue.includes(value)
        changes = isRemoved ? this.modelValue.filter(v => v !== value) : [...this.modelValue, value]
      }
      this.$emit('update:modelValue', changes)
      setTimeout(() => {
        this.height = this.$refs.search.clientHeight + 7.5
      }, 50)
    },
    removeOption(value) {
      const model = this.modelValue.filter(v => v !== value)
      this.$emit('update:modelValue', model)
      this.$emit('onBlur', false)
      this.$nextTick(() => {
        this.height = this.$refs.search.clientHeight + 7.5
      })
    },
    disabledOption(value) {
      return this.modelValue.length >= 4 && !this.modelValue.includes(value)
    },
    handleMouseLeave() {
      const addEl = document.getElementById(`${this.name}-multi-add`)
      if (this.isFocusEdit.some(f => f) || (addEl && document.activeElement === addEl)) return
      this.isFocus = false
      this.$refs.searchMulti.blur()
    },
    handleEditOption(idx) {
      if (this.isFocusEdit[idx]) {
        const editEl = document.getElementById(`${this.name}-multi-edit-${idx}`)
        if (!editEl.value) return
        const newOptions = this.options.map((option, i) => (i === idx ? { ...option, text: editEl.value } : option))
        this.$emit('update:options', newOptions)
        this.$set(this.isFocusEdit, idx, false)
        return
      }
      this.$set(this.isFocusEdit, idx, true)
      this.$nextTick(() => {
        const editEl = document.getElementById(`${this.name}-multi-edit-${idx}`)
        if (editEl) editEl.focus()
      })
    },
    handleAddOption() {
      if (this.loadingAddOption) return
      const addEl = document.getElementById(`${this.name}-multi-add`)
      if (!addEl.value) return
      const scrollToBottom = () => {
        this.$nextTick(() => {
          const group = document.getElementById(`${this.name}-group`)
          group.scrollTop = group.scrollHeight
          addEl.value = ''
        })
      }
      this.$emit('onAddOption', { text: addEl.value, toLast: scrollToBottom })
    },
    limitInput(e, id) {
      if (e.ctrlKey || e.metaKey) return
      const { value } = document.getElementById(id)
      if (value.length >= this.maxPusehedOptionLen && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(e.key)) {
        e.preventDefault()
      }
    },
  },
}
</script>

<style scoped>
#search-talent-lead {
  font-size: 14px;
}

.komsearch:has(#search-talent-lead:focus) {
  border-color: rgb(249, 80, 49);
}
</style>
